// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SchemaWrapper_wrapper__8jy0O"};